import React from 'react';
import { ServiceCard } from '../components/ServiceCard';
import { TrustBadge } from '../components/TrustBadge';
export function ServiceDetails() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-slate-50" data-id="element-463">
      {/* Header Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-464">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-465">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-466">
            Service Details
          </h1>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-467">
            Domisafe offers subscription-based software to help companies manage
            customers, tasks and updates. Choose the package that fits your
            business needs.
          </p>
        </div>

        {/* Service Packages */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-468">
          <ServiceCard name="Bronze" price="£99" features={['Task tracking', 'Customer record storage', 'Message dashboard', 'Secure access']} paymentLink="https://buy.stripe.com/00w6oHbtE7d6epQc2jeAg01" image="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop" data-id="element-469" />

          <ServiceCard name="Silver" price="£120" features={['Everything in Bronze', 'Team access', 'Activity monitoring', 'Automated reminders']} paymentLink="https://buy.stripe.com/4gM14n41c9le6Xo7M3eAg00" image="https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&h=300&fit=crop" popular={true} data-id="element-470" />

          <ServiceCard name="Gold" price="£150" features={['All features in Silver', 'Advanced reporting', 'Export tools', 'Multi-location support']} image="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=400&h=300&fit=crop" data-id="element-471" />
        </div>

        {/* Reassurance Block */}
        <div className="bg-white rounded-2xl shadow-lg p-8" data-id="element-472">
          <h2 className="text-2xl font-bold text-slate-900 text-center mb-6" data-id="element-473">
            Why Choose Domisafe?
          </h2>
          <p className="text-lg text-slate-600 text-center mb-8 max-w-2xl mx-auto" data-id="element-474">
            We're committed to providing reliable, secure software that helps
            your business run smoothly. All packages include ongoing support and
            regular updates.
          </p>

          <div className="flex flex-wrap gap-6 justify-center" data-id="element-475">
            <TrustBadge icon="location" text="UK-Based" data-id="element-476" />
            <TrustBadge icon="star" text="Trusted Service" data-id="element-477" />
            <TrustBadge icon="shield" text="Clear Pricing" data-id="element-478" />
            <TrustBadge icon="payment" text="Secure Payments" data-id="element-479" />
          </div>
        </div>
      </section>

      {/* Additional Info */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-480">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-481">
          <div className="bg-emerald-50 rounded-xl p-8" data-id="element-482">
            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-483">
              Flexible Subscriptions
            </h3>
            <p className="text-slate-700 leading-relaxed" data-id="element-484">
              All packages are billed monthly with no long-term contracts. You
              can upgrade, downgrade or cancel at any time according to your
              business needs.
            </p>
          </div>

          <div className="bg-teal-50 rounded-xl p-8" data-id="element-485">
            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-486">
              Quick Setup
            </h3>
            <p className="text-slate-700 leading-relaxed" data-id="element-487">
              Get started immediately after purchase. No downloads, no
              installation—simply log in with your credentials and begin
              organising your work straight away.
            </p>
          </div>
        </div>
      </section>
    </div>;
}